import { Component, OnInit } from '@angular/core';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-already-logged-in',
  templateUrl: './already-logged-in.component.html',
  styleUrls: ['./already-logged-in.component.scss']
})
export class AlreadyLoggedInComponent implements OnInit {

  userToken: any; 
  currentUser: any;
  userManageResponseHolder: any;
  userDetails: any;
  databaseId: string;
  organizationId: string;
  FirstName:string="";
  LastName:string="";
  FullName:string="";
  Email:string="";
  ImagePathURL:string="";

  constructor(private encryptionAlgo: EncryptionService, private formsService:FormsService,
    private reusableClass: ReusableClasses,private statusConst: StatusConstant,private router: Router) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);  
  }

  ngOnInit(): void {
    this.getUserDetailsManageUser();
  }

  getUserDetailsManageUser() {
    var ReqModel={
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
    } 
    this.formsService.getUserDetailsManageUser(ReqModel).subscribe(response => {
      if (response) {       
        this.userManageResponseHolder = response;
        if (this.userManageResponseHolder.status == this.statusConst.statusSuccess) {
          this.userDetails = this.userManageResponseHolder.data;
          this.FirstName  = this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.firstName); 
          this.LastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.lastName);
          this.FullName = this.FirstName+" "+this.LastName;
          this.Email=this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.userDetails.email);
          this.ImagePathURL =  (this.userDetails.profileImageUrl==null || this.userDetails.profileImageUrl==undefined || this.userDetails.profileImageUrl=='')?'':this.userDetails.profileImageUrl;    
        }
        else {
         
        }
      }
    });
  }

  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  logOutUser(){
   // sessionStorage.clear();
   //sessionStorage.clear();
    //sessionStorage.setItem('alreadyLogin','yes');
   // this.router.navigate(['/auth/login']);
  }

}
